import * as React from 'react';
import { A, $$, Hooks } from 'frontend';

import './ViewImage.css';
import { useExitToFolderShortcut, useRetainScroll } from '../hooks';
import { NextPrevLinks, useNextPrevSwipe } from './NextPrev';

export function ViewImage() {
  useRetainScroll();
  useExitToFolderShortcut();
  const dispatch = Hooks.useDispatch();
  const path = $$.getPath();
  const blob = $$.getDownloadBlobCache().get(path);
  const error = $$.getDownloadFileErrors().get(path);
  const songTitle = $$.getActiveFileSongTitleOrNull();

  React.useEffect(() => {
    if (songTitle) {
      document.title = songTitle;
    } else {
      const parts = path.split('/');
      const file = parts[parts.length - 1];
      document.title = file.replace(/\.\w+$/, '');
    }
  }, [path, songTitle]);

  React.useEffect(() => {
    if (!blob) {
      void dispatch(A.downloadBlob(path));
    }
  }, [blob]);

  const swipeDiv = React.useRef(null);
  useNextPrevSwipe(swipeDiv);

  if (!blob) {
    if (error) {
      return (
        <div className="status" ref={swipeDiv}>
          <NextPrevLinks />
          There was an error: {error}
        </div>
      );
    }
    return (
      <div className="status" ref={swipeDiv}>
        <NextPrevLinks />
        Downloading…
      </div>
    );
  }
  return <LoadImage />;
}

function LoadImage() {
  const image = $$.getActiveImageOrNull();
  const swipeDiv = React.useRef(null);
  useNextPrevSwipe(swipeDiv);

  if (image) {
    return (
      <div className="viewImage" data-fullscreen ref={swipeDiv}>
        <NextPrevLinks />
        <img src={image} />
      </div>
    );
  }
  return <div className="status">Loading image.</div>;
}
